export default __webpack_public_path__ + "static/media/mock-image.fc4f6525.jpg";